/* 切入、切出动画 */
import { Canvas, dep, DisplayObject, Filter, getDefaults } from '@tencent/alloy-renderer';
import { PresetSubtype } from '@tencent/slide-sdk-model';
import { AnimFilters, Action } from '../../anim-constants';
import { IAnimFilterOptions } from '../../anim-interface';

export default class CutFilter extends Filter {
    public static defaults: IAnimFilterOptions = {
        rate: 0,
        direction: PresetSubtype.Bottom,
        action: Action.ENTR,
    };

    @dep public rate: number;
    @dep public direction = PresetSubtype.Bottom;
    @dep public action = Action.ENTR;

    public forbidWebgl = true;
    public type = AnimFilters.CUT;

    public constructor(options: Partial<IAnimFilterOptions>) {
        super();
        const defaults = getDefaults<typeof CutFilter>(this);
        this.rate = options.rate ?? defaults.rate;
        this.direction = options.direction ?? defaults.direction;
        this.action = options.action ?? defaults.action;
    }

    public apply(obj: DisplayObject, canvas: Canvas) {
        this.action === Action.ENTR ? this.applyEntr(canvas) : this.applyExit(canvas);
    }


    /**
     * 入场滤镜
     * @param canvas Canvas
     */
    protected applyEntr = (canvas: Canvas) => {
        const { width, height } = canvas;
        let { x, y } = canvas.bounds;
        let  w = width;
        let h = height;
        if (this.direction === PresetSubtype.Bottom) {
            y += this.rate * height;
        }
        if (this.direction === PresetSubtype.Left)  {
            w = width - (this.rate * width);
        }
        if (this.direction === PresetSubtype.Top) {
            h = height - (this.rate * height);
        }
        if (this.direction === PresetSubtype.Right) {
            x += this.rate * width;
        }
        canvas.clearRect(x, y, w, h);
    };

    /**
     * 退场滤镜
     * @param canvas Canvas
     */
    protected applyExit = (canvas: Canvas) => {
        const { width, height } = canvas;
        let { x, y } = canvas.bounds;
        let  w = width;
        let h = height;
        if (this.direction === PresetSubtype.Bottom) {
            y += height - (this.rate * height);
        }
        if (this.direction === PresetSubtype.Left)  {
            w = this.rate * width;
        }
        if (this.direction === PresetSubtype.Top) {
            h = this.rate * height;
        }
        if (this.direction === PresetSubtype.Right) {
            x += width - (this.rate * width);
        }
        canvas.clearRect(x, y, w, h);
    };
}
